import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 92172 111818"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970274599072">
        <path
          d="M72812 82586V68400l-6683-1844c-584-1937-1349-3793-2278-5549l3399-5991-10029-10031-5847 3319c-1891-1043-3902-1893-6007-2528l-1868-6773H29313l-1868 6773c-2177 656-4251 1544-6196 2638l-5705-3238L5515 55205l3373 5945c-896 1713-1638 3520-2204 5406L0 68400v14186l6684 1843c597 1988 1387 3892 2349 5690l-3256 5739 10029 10030 5642-3203c1902 1049 3926 1901 6046 2536l1819 6597 14186-2 1820-6595c2047-614 4009-1428 5857-2427l5784 3282 10030-10029-3282-5785c998-1840 1809-3794 2421-5833l6683-1843zM36405 94253c-10406 0-18841-8436-18841-18842 0-10407 8435-18843 18841-18843s18843 8436 18843 18843c0 10406-8436 18842-18843 18842zM92172 26147l-629-8934-4292-865c-452-1193-1016-2330-1679-3394l1876-3923-6762-5872-3535 2350c-1238-574-2542-1021-3895-1327L71777 0l-8934 628-875 4348c-1341 510-2609 1161-3785 1935l-3736-1785-5872 6761 2388 3593c-490 1120-877 2292-1150 3504l-4127 1457 628 8934 4292 865c464 1225 1046 2391 1731 3480l-1797 3759 6760 5872 3412-2268c1245 577 2557 1025 3920 1329l1439 4073 8933-628 855-4234c1262-477 2463-1077 3581-1790l3789 1813 5872-6762-2324-3496c546-1204 970-2470 1266-3782l4129-1459zm-22412 8961c-6555 462-12241-4478-12702-11031-460-6554 4480-12241 11034-12701 6553-461 12239 4477 12700 11032 460 6553-4478 12239-11032 12700z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
